import { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import {
  LocalWidgetRouterContext,
  LocalWidgetRouterState,
  WidgetRouteContext,
} from '@/core/widgets/contexts/local-widget-router-context';

// <Outlet /> for widget layout routes: renders the matched child route under
// LocalWidgetRouter, or defers to react-router when the widget runs standalone.
export default function WidgetOutlet() {
  const context = useContext<LocalWidgetRouterState>(LocalWidgetRouterContext);
  const route = useContext(WidgetRouteContext);

  if (context.useLocal) {
    return <>{route?.outlet}</>;
  }

  return <Outlet />;
}
